import axios from "axios";
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Form,
  InputGroup,
  Button,
  Pagination,
  Spinner,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

const ExamDashboard = () => {
  const [search, setSearch] = useState("");

  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [students, setStudents] = useState([]);
  const [stats, setStats] = useState({});
  const [name, setName] = useState("");
  const [studentId, setStudentId] = useState("");
  const [rollNo, setRollNo] = useState("");
  const [assignment, setAssignment] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // const [loading, setLoading] = useState(true);  // <-- start as true
  const [hasFetched, setHasFetched] = useState(false); // optional guard

  const [loadingAssignment, setLoadingAssignment] = useState(true);
  const [loadingStudents, setLoadingStudents] = useState(false); 

   const navigate = useNavigate()

  const navigateToAnswerPage = (id) =>{
       navigate(`/answer-details/${id}`);


  }

 

  const fetchStudents = async () => {
  try {
    setLoadingStudents(true);

    const payload = {
      page: page.toString(), // <-- use page state
      perpage: "10",
      assignment_id: id,
      searchParam: {
        student_name: name || "",
        student_id: studentId || "",
        roll: rollNo || "",
      },
    };

    const res = await axios.post(
      "https://codydealms.codydeasoftech.in/api/teacher/assignmentAnswers",
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (res.data?.status) {
      const responseData = res.data;

      // ✅ get last_page from pagination object
      setTotalPages(responseData.data.pagination?.last_page || 1);

      // ✅ set stats correctly
      setStats({
        total: responseData.totalStudents,
        attempted: responseData.attemptedStudents,
        absent: responseData.absentStudents,
      });

      // ✅ Correct path (no extra .data)
      const answerList = responseData.data.assignment_answer || [];

      const formatted = answerList.map((s) => ({
        name: s.student_name,
        roll: s.roll,
        semester: s.semester_name,
        inTime: s.start_time ?? "Absent",
        outTime: s.end_time ?? "Absent",
        attendance_status: s.attendance_status ?? "Absent",
        answer_id: s.answer_id, // ✅ keep original value
        attemptedQus: s.answer_id ? "Attempted" : "—",
      }));

      console.log("Formatted Students:", formatted);

      setStudents(formatted);
    }
  } catch (err) {
    console.error("Error fetching assignment answers:", err);
  } finally {
    setLoadingStudents(false);
  }
};


  useEffect(() => {
    fetchStudents();
  }, [id, page]);

  useEffect(() => {
    if (name === "" && rollNo === "" && studentId === "") {
      setPage(1);
      fetchStudents();
    }
  }, [name, rollNo, studentId]);

  const fetchAssignmentDetails = async () => {
    try {
      setLoading(true);
      const payload = {
        id: id, // <-- from URL
        page: "1",
        perpage: "10",
        searchParam: {},
      };

      const res = await axios.post(
        "https://codydealms.codydeasoftech.in/api/teacher/fetchAssignmets",
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // <-- your token here
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data?.status) {
        setAssignment(res.data.data);
      } else {
        setAssignment(null);
      }
      setHasFetched(true);
    } catch (error) {
      console.error("Error fetching assignment details:", error);
    } finally {
      setLoadingAssignment(false);
    }
  };

  useEffect(() => {
    fetchAssignmentDetails();
  }, [id]);

  // if (loading) {
  //   return (
  //     <div className="text-center my-5">
  //       <div className="spinner-border text-primary" role="status"></div>
  //       {/* <span className="mt-2">Loading assignment details...</span> */}
  //     </div>
  //   );
  // }

  if (!assignment && hasFetched) {
    return (
      <div className="text-center my-5 text-muted">
        No assignment details found
      </div>
    );
  }

  return (
    <Container fluid className="mt-4">
      {loadingAssignment ? (
        <div className="text-center my-5">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      ) : assignment ? (
        <div
          className="card shadow-sm mb-3"
          style={{ borderRadius: "12px", overflow: "hidden" }}
        >
          <div className="card-body">
            <h3 style={{ color: "#5856d6" }}>{assignment.title}</h3>
            <p className="text-muted mb-3">
              {assignment.exam_master_name} • {assignment.department_name}
            </p>
            <div className="d-flex flex-wrap gap-3 mb-3">
              <span className="badge bg-success fw-bold fs-6">
                Paper Code: {assignment.paper_code}
              </span>
              <span className="badge bg-success fw-bold fs-6">
                Semester: {assignment.semester_name}
              </span>
              <span className="badge bg-success fw-bold fs-6">
                Total Marks: {assignment.total_marks}
              </span>
            </div>

            <div>Exam Date: {assignment.exam_date}</div>
          </div>
        </div>
      ) : (
        <div className="text-center my-5 text-muted">
          No assignment details found
        </div>
      )}

      {/* Search Card */}
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              fetchStudents(); // Call API when form is submitted (Search)
            }}
          >
            <Row className="g-3">
              <Col md={4}>
                <Form.Group controlId="formName">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group controlId="formRollNo">
                  <Form.Label>Roll No</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter roll no"
                    value={rollNo}
                    onChange={(e) => setRollNo(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group controlId="formStudentId">
                  <Form.Label>Student Id</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Student Id"
                    value={studentId}
                    onChange={(e) => setStudentId(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={2} className="d-flex align-items-end">
                <Button
                  type="submit"
                  variant="primary"
                  className="btn btn-primary w-100 w-md-auto"
                >
                  <i className="fa-solid fa-magnifying-glass"></i> Search
                </Button>
              </Col>

              <Col md={2} className="d-flex align-items-end">
                <Button
                  type="button"
                  variant="secondary"
                  className="btn btn-secondary w-100 w-md-auto"
                  onClick={() => {
                    setName("");
                    setRollNo("");
                    setStudentId("");
                  }}
                >
                  <i className="fa-solid fa-rotate-left"></i> Reset
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      {/* Summary Cards */}
      <Row className="mb-4">
        <Col md={4}>
          <Card
            className="text-center shadow-sm"
            style={{
              borderRadius: "10px",
              boxShadow: "0 8px 20px rgba(88, 86, 214, 0.2)",
              backgroundColor: "#799eff",
            }}
          >
            <Card.Body>
              <Card.Title>Total Students</Card.Title>
              <h3>{stats.total}</h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card
            className="text-center shadow-sm"
            style={{
              borderRadius: "10px",
              boxShadow: "0 8px 20px rgba(88, 86, 214, 0.2)",
              backgroundColor: "#ffde63",
            }}
          >
            <Card.Body>
              <Card.Title>Attempted Students</Card.Title>
              <h3>{stats.attempted}</h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card
            className="text-center shadow-sm"
            style={{
              borderRadius: "10px",
              boxShadow: "0 8px 20px rgba(88, 86, 214, 0.2)",
              backgroundColor: "#a3dc9a",
            }}
          >
            <Card.Body>
              <Card.Title>Absent Students</Card.Title>
              <h3>{stats.absent}</h3>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Students Table */}
<Card className="shadow-sm">
  <Card.Body>
    <h5 className="mb-3">Student Details</h5>

    {loadingStudents ? (
      // Table-level loader
     <div className="text-center my-5">
    <div className="d-flex flex-column align-items-center">
      <div className="spinner-border text-primary" role="status"></div>
      <span className="mt-2 fw-semibold text-muted">Fetching Students...</span>
    </div>
  </div>
    ) : students.length > 0 ? (
      <Table className="table table-striped table-hover table-responsive">
        <thead className="table-primary">
          <tr>
            <th>Sl No.</th>
            <th>Name</th>
            <th>Roll</th>
            <th>Semester</th>
            <th>In Time</th>
            <th>Out Time</th>
            <th>View</th>
            <th>Answers</th>
          </tr>
        </thead>
        <tbody>
          {students.map((s, index) => (
            <tr key={index}>
              <td>{(page - 1) * 10 + index + 1}.</td>
              <td>{s.name}</td>
              <td>{s.roll}</td>
              <td>{s.semester}</td>
              <td>{s.inTime}</td>
              <td>{s.outTime}</td>
              <td>{s.attendance_status}</td>
<td>
  {s.answer_id !== null && s.answer_id !== undefined ? (
    <Button
      size="sm"
      variant="primary"
      onClick={() => navigateToAnswerPage(s.answer_id)}
    >
      Click
    </Button>
  ) : (
    <span className="text-muted">No Answer</span>
  )}
</td>

            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <div className="text-center my-5 text-muted">No students found</div>
    )}

    {/* Pagination */}
    {totalPages > 1 && (
      <Pagination className="justify-content-center mt-3">
        <Pagination.Prev
          onClick={() => setPage((p) => Math.max(p - 1, 1))}
          disabled={page === 1}
        />
        {[...Array(totalPages)].map((_, i) => (
          <Pagination.Item
            key={i + 1}
            active={i + 1 === page}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
          disabled={page === totalPages}
        />
      </Pagination>
    )}
  </Card.Body>
</Card>

    </Container>
  );
};

export default ExamDashboard;
